<template>
    <div class="main-content events-list" v-cloak>
        <div class="container">
            <div class="events-group-header is-current">
                <div class="events-group-header-icon"><span>S</span></div>
                <div class="content">Support</div>
            </div>
            <p>
                You need help, contact us! <br />
                <a :href="link_url">support@wplan.events</a>
            </p>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
    name: "support",
    components: {},
    data() {
        return {};
    },
    computed: {
        ...mapState(["user"]),
        link_url(pl) {
            return "mailto:support@wplan.events?subject=" + this.user.username;
        }
    },
    methods: {
        ...mapActions(["get_logged_in_user"])
    },
    mounted() {
        this.get_logged_in_user();
    },
    created() {}
};
</script>
<style scoped>
p,
ul li {
    font-size: 1.2rem;
    line-height: 1.8rem;
}

ul {
    list-style-type: initial;
    margin-left: 14px;
}

ul li {
    margin-bottom: 0.4rem;
}

.container {
    margin-bottom: 4rem;
}

a {
    color: #00a8b3;
    word-break: break-word;
}

.events-group-header {
    margin-top: 3.2rem;
}

.events-group-item-header {
    margin-top: 2.4rem;
}

.events-group-header .content {
    flex: 1;
}
</style>
